import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    disableFileUpload: { type: Boolean, default: false }
  }

  connect () {
    super.connect()
    if (this.disableFileUploadValue) {
      this.bindOnFileAccept = this.#onFileAccept.bind(this)
      this.element.addEventListener('trix-file-accept', this.bindOnFileAccept)
    }

    this.bindOnBeforeMorphAttribute = this.onBeforeMorphAttribute.bind(this)
    this.bindOnBeforeMorphElement = this.onBeforeMorphElement.bind(this)
    this.bindOnMorphElement = this.onMorphElement.bind(this)

    this.element.addEventListener('turbo:before-morph-attribute', this.bindOnBeforeMorphAttribute)
    this.element.addEventListener('turbo:before-morph-element', this.bindOnBeforeMorphElement)
    this.element.addEventListener('turbo:morph-element', this.bindOnMorphElement)
  }

  disconnect () {
    this.element.removeEventListener('turbo:morph-element', this.bindOnMorphElement)
    this.element.removeEventListener('turbo:before-morph-element', this.bindOnBeforeMorphElement)
    this.element.removeEventListener('turbo:before-morph-attribute', this.bindOnBeforeMorphAttribute)

    if (this.disableFileUploadValue) {
      this.element.removeEventListener('trix-file-accept', this.bindOnFileAccept)
    }
    super.disconnect()
  }

  #onFileAccept (event) {
    event.preventDefault()
  }

  onBeforeMorphAttribute (event) {
    const { target } = event

    if ((target.tagName === 'TRIX-EDITOR' && !this.morphTrixEditor) || (target.tagName === 'TRIX-TOOLBAR' && !this.morphTrixToolbar)) {
      event.preventDefault()
    }
  }

  onBeforeMorphElement (event) {
    const { target, detail } = event

    if (target.tagName === 'TRIX-EDITOR') { this.morphTrixEditor = detail.currentElement.id !== detail.newElement?.id }
    if (target.tagName === 'TRIX-TOOLBAR') { this.morphTrixToolbar = detail.currentElement.id !== detail.newElement?.id }

    if ((target.tagName === 'TRIX-EDITOR' && !this.morphTrixEditor) || (target.tagName === 'TRIX-TOOLBAR' && !this.morphTrixToolbar)) {
      console.debug('skip')
      event.preventDefault()
    }
  }

  onMorphElement (event) {
    const { target } = event
    if (target.tagName === 'TRIX-EDITOR' && this.morphTrixEditor) {
      target.reset()
      target.disconnectedCallback()
      target.editorController = null
      target.connectedCallback()
    }
  }
}
